import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Geopoint } from "./geopoint";
export const protobufPackage = "snapchat.lenses";
export interface Geocircle {
    radius: number;
    center: Geopoint | undefined;
}
function createBaseGeocircle(): Geocircle {
    return { radius: 0, center: undefined };
}
export const Geocircle: MessageFns<Geocircle> = {
    encode(message: Geocircle, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.radius !== 0) {
            writer.uint32(9).double(message.radius);
        }
        if (message.center !== undefined) {
            Geopoint.encode(message.center, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): Geocircle {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGeocircle();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 9) {
                        break;
                    }
                    message.radius = reader.double();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.center = Geopoint.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<Geocircle>, I>>(base?: I): Geocircle {
        return Geocircle.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<Geocircle>, I>>(object: I): Geocircle {
        const message = createBaseGeocircle();
        message.radius = object.radius ?? 0;
        message.center = (object.center !== undefined && object.center !== null)
            ? Geopoint.fromPartial(object.center)
            : undefined;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {
    $case: string;
} ? {
    [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]>;
} & {
    $case: T["$case"];
} : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
